'use client';

import { useIdleMount } from '@repo/web-chrome/lib/use-idle-mount';
import { type ComponentType, useEffect, useState } from 'react';

type TiltComponentType = ComponentType<{ children: React.ReactNode }>;

interface IPhoneFrameTiltLazyProps {
  children: React.ReactNode;
}

export function PhoneFrameTiltLazy({ children }: IPhoneFrameTiltLazyProps): React.JSX.Element {
  const ready = useIdleMount();
  const [Tilt, setTilt] = useState<TiltComponentType | null>(null);

  useEffect(() => {
    if (!ready || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      return;
    }
    let cancelled = false;
    void import('./phone-frame-tilt').then((mod) => {
      if (!cancelled) {
        setTilt(() => mod.PhoneFrameTilt);
      }
    });
    return (): void => {
      cancelled = true;
    };
  }, [ready]);

  if (!Tilt) {
    return <div style={{ perspective: 1000 }}>{children}</div>;
  }
  return <Tilt>{children}</Tilt>;
}
